"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollOffPricingTypeLabels = exports.RollOffPricingType = exports.RollOffPricingTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RollOffPricingTypes = ['ton', 'yard', 'flat'];
exports.RollOffPricingType = typebox_1.Type.Union(exports.RollOffPricingTypes.map((m) => typebox_1.Type.Literal(m)));
exports.RollOffPricingTypeLabels = {
    ton: 'Ton',
    yard: 'Yard',
    flat: 'Flat',
};
//# sourceMappingURL=roll-off-pricing-types.js.map